module.exports = __webpack_public_path__ + "img/israel.5fd2184.webp";